// No imports needed for this simplified version

/**
 * Extremely simple header function optimized for thermal printers with Arabic text
 */
const createHeader = (restaurant, order, t, language) => {
  // Get restaurant name and address based on language
  const name = restaurant.name_ar || restaurant.name;
  const address = restaurant.address_ar || restaurant.address;
  
  // Format the date in Gregorian format (DD/MM/YYYY)
  let orderDate = new Date();
  if (order.created_at && !isNaN(new Date(order.created_at).getTime())) {
    orderDate = new Date(order.created_at);
  }
  
  // Format date in Gregorian format (DD/MM/YYYY)
  const day = String(orderDate.getDate()).padStart(2, '0');
  const month = String(orderDate.getMonth() + 1).padStart(2, '0');
  const year = orderDate.getFullYear();
  const hours = String(orderDate.getHours()).padStart(2, '0');
  const minutes = String(orderDate.getMinutes()).padStart(2, '0');
  
  const date = `${day}/${month}/${year}`;
  const time = `${hours}:${minutes}`;

  return `
    <!-- Ultra-simple header for maximum thermal printer compatibility -->
    <center>
      <!-- Restaurant Name with proper RTL handling -->
      <div dir="rtl" style="font-weight: bold; font-size: 12px; font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif; letter-spacing: 0;">
        ${language === 'ar' ? name : name}
      </div>
      
      <!-- Address -->
      ${address ? `<div dir="rtl" style="font-size: 10px; font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif; letter-spacing: 0;">${address}</div>` : ''}
      
      <!-- Phone -->
      ${restaurant.phone ? 
        `<div dir="rtl" style="font-size: 10px; font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif; letter-spacing: 0;">
          ${language === 'ar' ? t('cashier.receipt.phone') : t('cashier.receipt.phone')}: ${restaurant.phone}
        </div>` : ''
      }
      
      <!-- Divider -->
      <div style="border-bottom: 1px dashed #000; margin: 5px 0;"></div>
      
      <!-- Tax Invoice Title - ultra simple -->
      <div dir="rtl" style="
        font-size: 12px;
        font-weight: bold;
        padding: 3px 0;
        font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif;
        letter-spacing: 0;
      ">
        ${order.customer_type === 'company' 
          ? (language === 'ar' ? t('cashier.receipt.taxInvoice') : t('cashier.receipt.taxInvoice'))
          : (language === 'ar' ? t('cashier.receipt.simplifiedTaxInvoice') : t('cashier.receipt.simplifiedTaxInvoice'))
        }
      </div>
      
      <!-- Divider -->
      <div style="border-bottom: 1px solid #000; margin: 5px 0;"></div>
      
      <!-- Tax Number -->
      ${restaurant.tax_number ? 
        `<div dir="rtl" style="font-size: 10px;">
          ${language === 'ar' ? t('cashier.receipt.taxNumber') : t('cashier.receipt.taxNumber')}: ${restaurant.tax_number}
        </div>` : ''
      }
    </center>
    
    <!-- Order Details - kept extremely simple -->
    <div dir="rtl" style="
      display: flex;
      justify-content: space-between;
      font-size: 10px;
      margin: 5px 0;
    ">
      <div>
        ${language === 'ar' ? t('cashier.receipt.orderNumber') : t('cashier.receipt.orderNumber')}: 
        ${order.order_number}
      </div>
      <div>
        ${language === 'ar' ? t('cashier.receipt.date') : t('cashier.receipt.date')}: 
        ${date} ${time}
      </div>
    </div>
    
    <!-- Company information is now in its own template -->
    
    <!-- Final Divider -->
    <div style="border-bottom: 1px solid #000; margin: 5px 0;"></div>
  `;
};


export default createHeader;
